import type { ReactNode } from 'react';

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="node-grid flex min-h-svh items-center justify-center p-4">
      {children}
    </div>
  );
}
